import { staticPageMeta } from './routeManifest'

const playerTabLabels = {
  overview: 'Player overview',
  balances: 'Balances',
  transactions: 'Transaction history',
  gameplay: 'Gameplay history',
  security: 'Login / IP / devices',
  'notes-tags': 'Notes & tags',
  kyc: 'KYC summary',
  compliance: 'Compliance & RG',
}

export function lookupPageMeta(pathname) {
  if (staticPageMeta[pathname]) return staticPageMeta[pathname]
  const playerTab = pathname.match(
    /^\/players\/[^/]+\/(overview|balances|transactions|gameplay|security|notes-tags|kyc|compliance)$/
  )
  if (playerTab) {
    const key = playerTab[1]
    return {
      title: playerTabLabels[key] || 'Player',
      description: 'Player workspace tab — wire list/detail APIs.',
    }
  }
  const tournamentTab = pathname.match(
    /^\/tournaments\/[^/]+\/(overview|registrations|blinds|prizes|schedule)$/
  )
  if (tournamentTab) {
    const labels = {
      overview: 'Tournament overview',
      registrations: 'Registrations',
      blinds: 'Blind structure',
      prizes: 'Prize structure',
      schedule: 'Schedule & status',
    }
    return {
      title: labels[tournamentTab[1]] || 'Tournament',
      description: 'Tournament operations tab.',
    }
  }
  if (/^\/wallet\/transactions\/[^/]+$/.test(pathname)) {
    return { title: 'Transaction detail', description: 'Ledger movements, holds, and linked gameplay.' }
  }
  if (/^\/sit-and-go\/[^/]+$/.test(pathname) && pathname !== '/sit-and-go/new') {
    return { title: 'Sit & Go configuration', description: 'Payout table, speed, and lobby assignment.' }
  }
  if (/^\/fraud\/cases\/[^/]+$/.test(pathname)) {
    return { title: 'Fraud case', description: 'Evidence package, timeline, and disposition.' }
  }
  if (/^\/kyc\/reviews\/[^/]+$/.test(pathname)) {
    return { title: 'KYC review', description: 'Document checks, risk score, and decision panel.' }
  }
  if (/^\/promotions\/campaigns\/[^/]+$/.test(pathname)) {
    return { title: 'Campaign detail', description: 'Audience, creative, and performance.' }
  }
  if (/^\/promotions\/bonuses\/[^/]+$/.test(pathname) && !pathname.endsWith('/new')) {
    return { title: 'Bonus detail', description: 'Accrual health, liability, and overrides.' }
  }
  if (/^\/vip\/tiers\/[^/]+$/.test(pathname)) {
    return { title: 'VIP tier detail', description: 'Thresholds, benefits, and downgrade policy.' }
  }
  if (/^\/leaderboards\/[^/]+$/.test(pathname)) {
    return { title: 'Leaderboard detail', description: 'Season config, standings export, and disputes.' }
  }
  if (/^\/missions\/[^/]+$/.test(pathname)) {
    return { title: 'Mission detail', description: 'Objectives, telemetry, and rewards.' }
  }
  if (/^\/achievements\/[^/]+$/.test(pathname)) {
    return { title: 'Achievement detail', description: 'Unlock criteria and distribution.' }
  }
  if (/^\/support\/tickets\/[^/]+$/.test(pathname)) {
    return { title: 'Ticket detail', description: 'Thread, internal notes, and escalations.' }
  }
  if (/^\/tables\/[^/]+$/.test(pathname) && pathname !== '/tables/new') {
    return { title: 'Table detail', description: 'Occupancy, liquidity, and forced actions.' }
  }
  return {
    title: 'Admin',
    description: `Route metadata not yet defined for ${pathname}.`,
  }
}
